export default "__VITE_ASSET__cb7473b9__"